import React from 'react'
import { Stack, Skeleton } from '@mui/material'
import { Card } from 'packages/ui/Graph'

export const MonthlyPurchasesSkeleton = () => (
  <Stack flex={1}>
    <Card
      title=""
      legend={null}
      sx={{ borderRadius: 4 }}
    >
      <Stack direction="row" justifyContent="flex-end" gap={2} mt={2}>
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} variant="rectangular" width={100} height={20} animation="wave" sx={{ borderRadius: 1, bgcolor: '#EFEFEF' }} />
        ))}
      </Stack>
      <Stack direction="row" height={350} alignItems="flex-end" spacing={2} px={2}>
        {[...Array(12)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width="100%"
            height={`${Math.random() * (80 - 20) + 20}%`}
            animation="wave"
            sx={{ borderRadius: 1, bgcolor: '#EFEFEF' }}
          />
        ))}
      </Stack>
    </Card>
  </Stack>
)
